import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import HandoverSessionLineDetail from '../entities/handoversessionlinedetail'
import PackageInfo from '../entities/handoversessionpackageinfo'
import appconst from './../../lib/appconst';

interface HandoverSessionLineState extends ListState<PackageInfo>{
}
class HandoverSessionLineMutations extends ListMutations<HandoverSessionLineDetail>{
}
class HandoverSessionLineModule extends ListModule<HandoverSessionLineState,any,PackageInfo>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:5,
        list: new Array<PackageInfo>(),
        loading:false
    }
    actions={
       async export(context:ActionContext<HandoverSessionLineState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/exportHandoverSessionPackages/`+payload.data.id+`/`+payload.data.code, "_blank");    
        }
    };
    mutations={
        setCurrentPage(state:HandoverSessionLineState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:HandoverSessionLineState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const handoverSessionLineModule=new HandoverSessionLineModule();
export default handoverSessionLineModule;